export enum TrafficRequestTypeEnum {
  RECOMMENDATIONS = "RECOMMENDATIONS",
  NEW_TERMS = "NEW_TERMS",
  // GROWTH_TERMS = "GROWTH_TERMS" // TODO: LIMONAD-7300
}